//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goodsCard from './components/goods-card.vue'
import { getOrderView, receipt } from '@/api/jianianhua'
export default {
  components: { goodsCard },
  data () {
    return {
      webServer: this.$config.baseUrl,
      id: this.$route.params.id,
      obj: {}
    }
  },
  mounted () {
    this.getinfor()
  },
  methods: {
    getinfor () {
      getOrderView({
        orderid: this.id
      }).then(data => {
        this.obj = data.returnValue
      })
    },
    // complaint (productid, orderid) {
    //   this.$router.push({ name: 'ceshicomplaint', query: { productid: productid, orderid: orderid } })
    // },
    examine (id) {
      console.log(id)
      this.$router.push({ name: 'jianianhualogistics', params: { id: id } })
    },
    // evaluate (id) {
    //   this.$router.push({ name: 'ceshievaluate', query: { id: id } })
    // },
    certain (id) {
      var _this = this
      this.$vux.confirm.show({
        content: '请确认您已经收到商品！',
        onConfirm () {
          receipt({
            id: id
          }).then(res => {
            _this.getinfor()
            if (res.success) {
              _this.$vux.alert.show({
                content: '确认收货成功',
                onHide () {
                  // location.reload()
                }
              })
            }
          })
        }
      })
    }
  }
}
